// extracted by mini-css-extract-plugin
export default {"no-default-button-style":"globals__no-default-button-style__TgZap","noDefaultButtonStyle":"globals__no-default-button-style__TgZap"};